export default __webpack_public_path__ + "assets/Onboarding_My_Apps.png";